import axios from "axios";
import { useEffect, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let tokenGetter = null;
export const setTokenGetter = (fn) => { tokenGetter = fn; };

export const api = axios.create({ baseURL: API });
api.interceptors.request.use(async (config) => {
  if (tokenGetter) {
    const token = await tokenGetter();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const cache = new Map();
export function useFetch(url, { cacheable = false } = {}) {
  const [state, setState] = useState({ data: cacheable ? cache.get(url) : undefined, loading: !(cacheable && cache.has(url)), error: null });
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!url) return;
    let alive = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    api.get(url).then((r) => {
      if (cacheable) cache.set(url, r.data);
      if (alive) setState({ data: r.data, loading: false, error: null });
    }).catch((e) => alive && setState({ data: undefined, loading: false, error: e }));
    return () => { alive = false; };
  }, [url, tick, cacheable]);
  return { ...state, reload: () => setTick((x) => x + 1) };
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join(", ");
  if (d?.code) return d.code;
  return e?.message || "error";
};
